import { LOCATION_CHANGE, LocationChangeAction } from "connected-react-router";
import { Reducer } from "redux";

import {
    BLOG_POST_SET_COMMENTS_OPENED,
    BlogPostSetCommentsOpenedAction,
} from "@/mk2/apps/blogs/components/BlogPost/BlogPost.actions";
import { tupdate } from "@/mk2/helpers/types";
import { HistoryLocationState } from "@/mk2/services/browserHistory";

export interface BlogPostState {
    commentsOpened: boolean;
}

export const initialBlogPostState: BlogPostState = {
    commentsOpened: false,
};

export interface BlogPostsState {
    [blogPostId: number]: BlogPostState;
}

export const initialBlogPostsState: BlogPostsState = {};

declare type BlogPostssReducerAction =
    | BlogPostSetCommentsOpenedAction
    | LocationChangeAction<HistoryLocationState>;

const blogPostsReducer: Reducer<BlogPostsState> = (
    state: BlogPostsState = initialBlogPostsState,
    action: BlogPostssReducerAction,
) => {
    switch (action.type) {
        case LOCATION_CHANGE: {
            return initialBlogPostsState;
        }
        case BLOG_POST_SET_COMMENTS_OPENED: {
            const key = action.postId;
            const subState = state[key] || initialBlogPostState;
            return tupdate(state, {
                [key]: tupdate(subState, {
                    commentsOpened: action.commentsOpened,
                }),
            });
        }

        default:
            return state;
    }
};

export default blogPostsReducer;
